export const incidentSourceIdsSettingName = 'incidentSourceIds';
export const incidentSourceSettingNames = {
  webchat: 'liveChat',
};
